<template>
  <AppLayout title="Settings">
    <form @submit.prevent="submit">
      <FormLayoutMultiColumnCard columns="grid-cols-6" gap="gap-4">
        <template #header>
          <CardHeadingWithDescriptionAction
            title="Notifications"
            description="Make changes to your notification preferences"
          />
        </template>

        <div class="col-span-6 sm:col-span-4">
          <ToggleWithLabel
            v-model="form.all_trip_notifications"
            label="Receive notifications for all trips"
          />
        </div>

        <template #bottom>
          <ButtonFormSave :form="form" />
        </template>
      </FormLayoutMultiColumnCard>
    </form>
  </AppLayout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import { useForm } from '@inertiajs/inertia-vue3'
import FormLayoutMultiColumnCard from '@/Common/Forms/FormLayouts/FormLayoutMultiColumnCard.vue'
import CardHeadingWithDescriptionAction from '@/Common/Headings/CardHeadings/CardHeadingWithDescriptionAction.vue'
import ToggleWithLabel from '@/Common/Forms/Toggles/ToggleWithLabel.vue'
import ButtonFormSave from '@/Common/Elements/Buttons/ButtonFormSave.vue'

const props = defineProps({
  user: Object,
})

const form = useForm({
  all_trip_notifications: !!props.user.all_trip_notifications,
})

function submit() {
  form.put(route('settings.update'))
}
</script>
